<template>
  <div>
    <Head title="Dados vitais" />
    <div class="shadow_box rounded-lg p-6">
      <div class="mb-6 flex flex-nowrap items-center">
        <h1 class="mr-3 text-2xl text-gray-777 font-roboto uppercase">Dados vitais</h1>
      </div>
      <data-table
        v-if="loadTable"
        v-model:columns="columns"
        route="vital-data/list"
        no-data-label="Nenhuma pergunta cadastrada"
        no-result-label="Nenhuma pergunta encontrada"
      >
        <template #table.cell.content.vital_data_status="{ value, row }">
          <switch-input v-model="row.status" label-checked="Ativo" label-unchecked="Inativo" @click="changeStatus(row)" />
        </template>
        <template #grid.content.body.vital_data_status="{ value, row }">
          <switch-input v-model="row.status" label-checked="Ativo" label-unchecked="Inativo" @click="changeStatus(row)" />
        </template>

        <template #table.cell.content.vital_data_photo="{ value, row }">
          <img v-if="row.photo?.url" :src="row.photo.url" class="max-w-[100px]" />
        </template>
        <template #grid.content.body.vital_data_photo="{ value, row }">
          <img v-if="row.photo?.url" :src="row.photo.url" class="max-w-[100px]" />
        </template>

        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 gap-4 ">
            <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-primary text-lg cursor-pointer" /></span>
            <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
          </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 gap-4 ">
            <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-primary text-lg cursor-pointer" /></span>
            <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
          </div>
        </template>

        <template #after.reload-button>
          <div class="flex flex-col lg:flex-row w-full">
            <button class="flex justify-center items-end font-roboto font-medium btn-primary uppercase w-full" @click.prevent="openModalConfig">
              <font-awesome-icon icon="fa-cog" class="text-white text-lg mr-2" /><span class=""> Reordenar Perguntas</span>
            </button>
            <button class="flex justify-center items-end font-roboto font-medium btn-primary uppercase w-full mt-4 ml-0 lg:ml-2 lg:mt-0" @click.prevent="openModalEdit({})">
              <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-2" /><span class=""> Adicionar Pergunta</span>
            </button>
          </div>
        </template>
      </data-table>
    </div>
    <modal-delete ref="modalDelete" @confirm="reloadTable" />

    <modal-edit ref="modalEdit" title="Pergunta" url="vital-data" :multipart="true" @submitForm="reloadTable">
      <template #form="{item}">
        <photo-input v-model="item.photo" :crop="false" :error="item.errors[`photo.upload`]" class="w-full" type="file" label="Imagem da pergunta" />
        <text-input v-model="item.question" :error="item.errors.question" class="w-full" label="Pergunta" />
        <checkbox-input v-model="item.type" :options="answer_types_options" :error="item.errors.type" class="w-full lg:w-2/3 lg:pr-6 mt-6" label="Tipo da resposta" />
        <switch-input v-model="item.status" class="w-full mt-6 lg:w-1/3" label="Situação" label-checked="Ativo" label-unchecked="Inativo" />

        <div v-if="item.type.indexOf('text') >= 0">
          <button class="btn-primary mt-6 flex items-end font-roboto font-normal text-xs px-6 py-2.5" @click.prevent="item.answers_text.push({});">
            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /> Adicionar campo de texto
          </button>
          <div v-if="item.errors.answers_text" class="form-error">{{ item.errors.answers_text }}</div>
          <div v-for="(answer_text, answer_index) in item.answers_text" class="w-full flex flex-wrap p-6 mt-4 bg-gray-100/50">
            <text-input v-model="answer_text.text" :error="item.errors[`answers_text.`+answer_index+`.text`]" class="pr-6 w-5/6 lg:w-11/12" label="Inserir informação do campo de texto" />
            <div class="mt-6 lg:mt-0 w-1/6 lg:w-1/12 self-center text-right">
              <span @click="deleteAnswerText(item, answer_text)"><font-awesome-icon icon="fa-xmark" class="text-gray-600 text-lg cursor-pointer" /></span>
            </div>
          </div>
        </div>

        <div class="w-full mt-2" />

        <div v-if="item.type.indexOf('option') >= 0" class="w-full">
          <button class="btn-primary mt-6 flex items-end font-roboto font-normal text-xs px-6 py-2.5" @click.prevent="item.answers_option.push({});">
            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /> Adicionar campo de múltipla escolha
          </button>
          <div v-if="item.errors.answers_option" class="form-error">{{ item.errors.answers_option }}</div>
          <div v-for="(answer_option, answer_index) in item.answers_option" class="w-full flex flex-wrap p-6 mt-4 bg-gray-100/50">
            <text-input v-model="answer_option.text" :error="item.errors[`answers_option.`+answer_index+`.text`]" class="pr-6 w-5/6 lg:w-11/12" label="Inserir valor do campo" />
            <div class="mt-6 lg:mt-0 w-1/6 lg:w-1/12 self-center text-right">
              <span @click="deleteAnswerOption(item, answer_option)"><font-awesome-icon icon="fa-xmark" class="text-gray-600 text-lg cursor-pointer" /></span>
            </div>
          </div>
        </div>
      </template>
    </modal-edit>

    <modal ref="modalConfig" size="modal-lg" :modal-scrollable="true" :modal-backdrop="true">
      <template #header>
        <div class="text-gray-777 font-roboto uppercase">
          <span>Perguntas - Ordenação</span>
        </div>
      </template>

      <template #body>
        <form action="">
          <div class="flex justify-center">
            <div class="w-full m-2">
              <draggable class="list-group list-group-selected" item-key="id" :list="formConfig.vitalDataOrdered">
                <template #item="{element}">
                  <div class="mb-4 list-group-item">
                    {{ element.question }}
                    <input type="hidden" name="selected" :value="element.id" />

                    <draggable class="mt-2 list-group list-group-selected" item-key="id" :list="element.answers_text">
                      <template #item="{element}">
                        <div class="list-group-item">
                          {{ element.text }}
                          <input type="hidden" name="selected" :value="element.id" />
                        </div>
                      </template>
                    </draggable>

                    <draggable class="mt-2 list-group list-group-selected" item-key="id" :list="element.answers_option">
                      <template #item="{element}">
                        <div class="list-group-item">
                          {{ element.text }}
                          <input type="hidden" name="selected" :value="element.id" />
                        </div>
                      </template>
                    </draggable>

                  </div>
                </template>
              </draggable>
            </div>
          </div>
        </form>
      </template>
      <template #footer>
        <button type="button" class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="closeModalConfig">Cancelar</button>
        <loading-button :loading="loadModalConfig" class="btn-primary px-6 py-2.5 text-xs leading-tight uppercase ml-1" type="submit" @click.prevent="saveModalConfig">Salvar</loading-button>
      </template>
    </modal>
  </div>
</template>

<script>
import { Head, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout/Layout'
import LoadingButton from '@/Shared/Components/LoadingButton'
import ModalDelete from '@/Shared/Modal/ModalDelete'
import ModalEdit from '@/Shared/Modal/ModalEdit'
import SwitchInput from '@/Shared/Fields/SwitchInput'
import TextInput from '@/Shared/Fields/TextInput'
import DataTable from '@/Shared/Components/DataTable'
import SelectInput from '@/Shared/Fields/SelectInput'
import Modal from '@/Shared/Modal/Modal'
import draggable from 'vuedraggable'
import CheckboxInput from '@/Shared/Fields/CheckboxInput'
import PhotoInput from '@/Shared/Fields/PhotoInput'

export default {
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    SwitchInput,
    TextInput,
    DataTable,
    SelectInput,
    Modal,
    draggable,
    CheckboxInput,
    PhotoInput,
  },
  layout: Layout,
  props: {
    answer_types_options: Object,
  },
  data() {
    return {
      loadModalConfig: false,
      vitalDataOrdered: null,
      loadTable: true,
      columns: [
        {
          uniqid: 'vital_data_photo',
          label: 'Imagem',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.photo ? row.photo : '',
        },
        {
          uniqid: 'vital_data_question',
          label: 'Pergunta',
          field: 'question',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'vital_data_type',
          label: 'Tipo',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.type_label ? row.type_label : '',
        },
        {
          uniqid: 'vital_data_status',
          label: 'Situação',
          field: 'status',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  mounted() {
    this.loadOptions()
  },
  methods: {
    changeStatus(item) {
      item.status = !item.status
      this.$inertia.post('/vital-data/update-status', item, {
        onFinish: () => {
          this.reloadTable()
        },
      })
    },
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/vital-data/${item.id}`, `Deseja realmente excluir a pergunta ${item.question}?`)
    },
    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        question: item.question,
        type: item.type ?? [],
        status: item.status ?? true,
        photo: item.photo ?? {},
        answers_text: item.answers_text ?? [],
        answers_option: item.answers_option ?? [],
        errors: {},
      })
    },
    reloadTable() {
      this.loadTable = false
      this.loadOptions()
      setTimeout(() => this.loadTable = true, 10)
    },
    deleteAnswerText(item, answer_text) {
      item.answers_text.splice(item.answers_text.indexOf(answer_text), 1)
    },
    deleteAnswerOption(item, answer_option) {
      item.answers_option.splice(item.answers_option.indexOf(answer_option), 1)
    },
    closeModalConfig() {
      this.$refs.modalConfig.showModal = false
    },
    openModalConfig() {
      this.formConfig = useForm({
        vitalDataOrdered: [].concat(this.vitalDataOrdered),
      })
      this.$refs.modalConfig.showModal = true
    },
    saveModalConfig() {
      this.formConfig.post('/vital-data/update-config', {
        onFinish: () => {
          if(!Object.keys(this.formConfig.errors).length) {
            this.closeModalConfig()
            this.loadOptions()
          } else {
            this.loadModalConfig = false
          }
        },
      })
    },
    async loadOptions() {
      await fetch(
        'vital-data/get-options',
      ).then(res => {
        res.json().then(json => {
          this.vitalDataOrdered = json.vitalDataOrdered
        })
      })
    },
  },
}
</script>
<style>
  .list-group {
    @apply flex flex-col;
  }

  .list-group-item {
    @apply text-black first:rounded-tl first:rounded-tr
    relative block py-3 px-9 border cursor-move bg-gray-200
    hover:bg-gray-300;
  }
</style>
